"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const DataProvider_1 = tslib_1.__importDefault(require("../DataProvider"));
class PurchasedFileProvider extends DataProvider_1.default {
    get fragments() {
        return {
            PurchasedFile: () => `
        ... on PurchasedFile {
          id
          userId
          ownerId
          subject {
            ${this.getFragment("Subject")}
          } 
          metadata
          urlPart
          time
          uuid
        }
      `,
            PurchasedFileDetails: () => `
        ... on PurchasedFileDetails {
          metadata
          urlPart
        }
      `,
            PurchasedFileOwner: () => `
        ... on PurchasedFileOwner {
          ownerId
          owner {
            ${this.getFragment("UserPublicData")}
          }
          files {
            ${this.getFragment("PurchasedFileDetails")}
          }
          fileCount
        }
      `,
        };
    }
    search({ data }) {
        return this.query("purchasedFileSearch", { data }, this.getPageableFragment("PurchasedFile"));
    }
    searchOwners({ data }) {
        return this.query("purchasedFileSearchOwners", { data }, this.getPageableFragment("PurchasedFileOwner"));
    }
}
exports.PurchasedFileProvider = PurchasedFileProvider;
//# sourceMappingURL=PurchasedFileProvider.js.map